import React from 'react';

import { useQuery } from '@apollo/client/react';
import { useUser } from '@repo/hooks/useUser';

import { MainView } from '@repo/ui/Views';

import DIDS_SHOW_Q from '../gql/show.gql';
import DidTabNav from '../components/DidTabNav';

import AutoResponderCrudForm from '@/features/autoResponders/components/AutoResponderCrudForm';

import { POLICIES, Authorization } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';
import { useParams } from 'react-router';

const DidAutoResponders = () => {
  const user = useUser();

  const params = useParams();
  const didId = params.didId;

  const { loading, error, data } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  console.error(error);

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />

      <Authorization
        policyCheck={POLICIES['messaging_auto_responses:index'](user)}
        fallbackView={
          <FallbackCard
            title="No access"
            description="You do not have the permissions to view auto replies."
          />
        }
      >
        <AutoResponderCrudForm
          canUpdate={POLICIES['messaging_auto_responses:update'](user)}
          canDelete={POLICIES['messaging_auto_responses:delete'](user)}
          didId={String(didId)}
        />
      </Authorization>
    </MainView>
  );
};

export default DidAutoResponders;
